<div class="col-12 banner">
    <app-slider [images]="this.banners" *ngIf="banners.length > 0"></app-slider>
</div>
<div class="col-10 offset-1">
    <app-content [Text]="content?.HTML"></app-content>
</div>
